import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { commissionSplitsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseAddCommissionSplitMutationProps = {
	onSuccess?: (result) => void;
	onError?: (error: ErrorResponse) => void;
};

type UseMutationProps = {
	agentId: string;
	commissionSplitData: { [key: string]: any };
};

const useAddCommissionSplitMutation = ({
	onSuccess,
	onError,
}: UseAddCommissionSplitMutationProps = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ agentId, commissionSplitData }: UseMutationProps) => {
			return commissionSplitsService.addCommissionSplit(
				agentId,
				commissionSplitData,
			);
		},
		{
			onSuccess(result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Commission Split has been successfully added.",
					}),
				);
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useAddCommissionSplitMutation;
